import { render } from "./ProjectCardBadge.vue?vue&type=template&id=74e377da"
import script from "./ProjectCardBadge.vue?vue&type=script&lang=js"
export * from "./ProjectCardBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__